export default class AudioService {

  constructor() {
    'ngInject';

    this.effects = {
      buttonClick: new Audio('/assets/mp3/buttonClick.mp3'),
      checkboxClick: new Audio('/assets/mp3/checkboxClick.mp3'),
      exerciseComplete: new Audio('/assets/mp3/success.m4a'),
      tab: new Audio('/assets/mp3/tab.m4a'),
      wrongAnswer: new Audio('/assets/mp3/wrong-answer.wav')
    };

  }

  play(effect) {
    try {
      this.effects[effect].play();
    } catch (e) {
      console.log(`Error while plaing effect for ${effect}`, e);
    };
  }

}



// WEBPACK FOOTER //
// ./client/app/services/audio.service.js